
































  import EntetePage from '@/commun/components/entete-page/entete-page.vue';
  import { DemandesTableau } from '@/components/demandes/tableau';
  import { DemandesTableauColonnesNom } from '@/components/demandes/tableau/demandes-tableau-colonnes';
  import Demande from '@/domain/models/demande';
  import Routes from '@/router/routes';
  import Vue from 'vue';
  import {
    chargerVariablesEnvironnement,
    ENVIRONNEMENTS_VUE_CLI,
  } from '@/setup/variables-environnement-gof';

  export default Vue.extend({
    name: 'DemandesGestion',
    components: {
      EntetePage,
      DemandesTableau,
    },
    data: () => ({
      afficherBoutonCreerDemande: false,
      colonnesAffichees: [
        DemandesTableauColonnesNom.Numero,
        DemandesTableauColonnesNom.DateDepot,
        DemandesTableauColonnesNom.Session,
        DemandesTableauColonnesNom.Faculte,
        DemandesTableauColonnesNom.Type,
        DemandesTableauColonnesNom.CoursProgramme,
        DemandesTableauColonnesNom.Etat,
      ],
      colonneTri: DemandesTableauColonnesNom.DateDepot,
      routeTraitementDemande: Routes.TraitementDemande,
      baseUri: '',
    }),
    computed: {
      demandes(): Demande[] {
        return this.$store.getters.demandes;
      },
    },
    async created(): Promise<void> {
      await this.$store.dispatch('obtenirDemandes');
      const environnement = process.env
        .NODE_ENV as keyof typeof ENVIRONNEMENTS_VUE_CLI;
      let variables = await chargerVariablesEnvironnement(environnement);
      this.baseUri = variables.base_uri;
    },
  });
